import { createRouter } from "@tanstack/solid-router";
import { pluginRoutes } from "@/composition";
import { rootRoute } from "@/routes/__root";
import { indexRoute } from "@/routes/home";
import { sendRoute } from "@/routes/send";
import { receiveRoute } from "@/routes/receive";
import { historyRoute } from "@/routes/history";
import { deferredRoute } from "@/routes/deferred";
import { accountRoute } from "@/routes/account";
import { NotFoundRoute } from "@/components/not-found-route";

const routeTree = rootRoute.addChildren([
  indexRoute,
  sendRoute,
  receiveRoute,
  historyRoute,
  deferredRoute,
  accountRoute,
  ...pluginRoutes,
]);

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  // Unknown URL → "not found page" state with a CTA to home.
  defaultNotFoundComponent: NotFoundRoute,
});

declare module "@tanstack/solid-router" {
  interface Register {
    router: typeof router;
  }
}
